module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/iPhone-back-190fd78c75ab6fed2ae978a1ea912340.svg";